<crm-tree-select
  class="block {{ styleClass }}"
  [options]="_nomenclatures"
  [(selectedItem)]="_selectedNomenclature"
  [label]="label"
  [disabled]="disabled"
  [groupsDisabled]="groupsDisabled"
  [scrollHeight]="scrollHeight"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [filter]="true"
  (panelShow)="panelShow.emit()"
  (panelHide)="panelHide.emit()"
  (selectedItemChange)="selectNomenclaturesHandler($event)"
  [panelStyleClass]="panelStyleClass"
  display="comma"
  selectionMode="single"></crm-tree-select>
